import { Subject } from 'rxjs'

type LogItem = {
  method: keyof Console | 'crumb'
  args: any
}

class ConsoleApi {
  history: LogItem[] = []
  onEvent$ = new Subject<LogItem>()

  // constructor () {
  //   this.onEvent$.subscribe((event) => {
  //     this.history.push(event)
  //   })
  // }

  clear () {
    this.history = []
  }

  install () {
    patchMethod('log', this)
    patchMethod('info', this)
    patchMethod('error', this)
    patchMethod('warn', this)
  }

  uninstall () {
    revertMethod('log')
    revertMethod('info')
    revertMethod('error')
    revertMethod('warn')
  }
}

export const consoleApi = new ConsoleApi()

declare global {
  interface Window {
    __consoleApi: ConsoleApi
  }
}
window.__consoleApi = consoleApi

function patchMethod (method: keyof Console, api: ConsoleApi) {
  if (console[method].__originMethod) {
    return
  }

  const prevMethod = console[method]
  const nextMethod = (...args: any[]) => {
    api.onEvent$.next({
      method,
      args,
    })
    return prevMethod(...args)
  }

  nextMethod.__originMethod = prevMethod
  console[method] = nextMethod
}

function revertMethod (method: keyof Console) {
  if (!console[method].__originMethod) {
    return
  }

  console[method] = console[method].__originMethod
}


